// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__FwpPU","bigColWidth":"Table_bigColWidth__3l_GL","biggerColWidth":"Table_biggerColWidth__1YqU3","row":"Table_row__2HxqD","col":"Table_col__1qc82"};